import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { OfferStatus } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

import { useReservationOfferStore } from '@/entities/reservation'
import { restrict } from '@/shared/lib/auth.ts'

import { reserveAgainStatuses } from '../config/reserveAgainStatuses.ts'

export const useReserve = (offer: Offer | null) => {
	const { t } = useTranslation('room-page')

	const setOffer = useReservationOfferStore.use.setOffer()
	const navigate = useNavigate()

	const status = offer?.IDs.status
	const isDisabled = status === OfferStatus.TRIP_COMPLETED

	// TODO: on TRIP_COMPLETED status open offer configuration
	const onButtonClick = () => {
		restrict(() => {
			setOffer(offer)
			navigate('/reservation/load')
		})
	}

	const name =
		status && reserveAgainStatuses.includes(status)
			? t('reserveAgain')
			: t('reserve')

	return {
		onButtonClick,
		name,
		title: t('reservationButton', { ns: 'tooltips' }),
		isDisabled
	}
}
